import { reatomAsync, withDataAtom } from "@reatom/async";
import { atom } from "@reatom/framework";

import { APIKnowledge } from "./knowledge.constants";

const requestedSlugAtom = atom<string | null>(
  null,
  "knowledgePage.requestedSlug",
);

export const knowledgePage = reatomAsync(async (ctx, slug: string) => {
  requestedSlugAtom(ctx, slug);

  const res = await fetch(
    `${APIKnowledge}/items/docsPoizon?filter[slug][_eq]=${encodeURIComponent(slug)}&fields=id,title,slug,order,content,status`,
  );

  const json = await res.json();

  return json.data?.[0] ?? null;
}, "knowledgePage").pipe(
  withDataAtom(null, (ctx, payload, state) =>
    payload?.slug === ctx.get(requestedSlugAtom) ? payload : state,
  ),
);
